import { render, staticRenderFns } from "./ObservationMobileCard.vue?vue&type=template&id=6b638a55&scoped=true"
import script from "./ObservationMobileCard.vue?vue&type=script&lang=js"
export * from "./ObservationMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b638a55",
  null
  
)

export default component.exports